import React from 'react';

import DesktopAppBar from './DesktopAppBar.component';
import MobileAppBar from './MobileAppBar.component';
import { useIsDesktop } from '../hooks/use-is-desktop.hook';

const PublicHeader: React.FC = () => {
  const isDesktop = useIsDesktop();

  return isDesktop ? <DesktopAppBar /> : <MobileAppBar />;
};

export default PublicHeader;
